import { APIService } from "../../../../../../network/api/APIService"
export const DashboardEA = ({owner=null}) => {
    let endpoint = `/dashboard/ea-top-seller/`;
    const params = [];

    if (owner !== null) params.push(`owner=${encodeURIComponent(owner)}`);

    if (params.length > 0) {
        endpoint += '?' + params.join('&');
    }

    return APIService({
        endpoint: endpoint,
        method: "GET",
        credentials: "include"
    });

}